import { Coins } from "lucide-react";

// Carteira do cliente (v1.5.316+): saldo de cashback disponível. Só informa —
// o switch de USAR fica na etapa de pagamento. Quem decide se aparece (cashback
// ativo, cliente logado, saldo > 0) é a página.
export default function CarteiraCashback({ saldo, darkMode, className = "" }) {
  return (
    <div className={`px-3 py-2 flex items-center justify-center gap-2 ${darkMode ? "bg-emerald-900/20 border-b border-emerald-800/40" : "bg-emerald-50 border-b border-emerald-200"} ${className}`}>
      <Coins className={`w-4 h-4 shrink-0 ${darkMode ? "text-emerald-400" : "text-emerald-600"}`} />
      <span className={`text-[12px] font-semibold ${darkMode ? "text-emerald-300" : "text-emerald-800"}`}>
        Carteira: <strong className={darkMode ? "text-emerald-200" : "text-emerald-900"}>R$ {Number(saldo || 0).toFixed(2).replace(".", ",")}</strong>
        <span className={`ml-1 text-[10px] font-normal ${darkMode ? "text-emerald-400/80" : "text-emerald-700/80"}`}>· use no pagamento</span>
      </span>
    </div>
  );
}
